module.exports = __webpack_public_path__ + "img/apointment.d833670d.svg";